import { render } from "./EstateDetail.vue?vue&type=template&id=b87edaf2&scoped=true"
import script from "./EstateDetail.vue?vue&type=script&lang=js"
export * from "./EstateDetail.vue?vue&type=script&lang=js"

import "./EstateDetail.vue?vue&type=style&index=0&id=b87edaf2&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/inqi/inqi-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b87edaf2"]])

export default __exports__